module.exports = __webpack_public_path__ + "static/media/feature-rewards.71ee33e9.svg";